/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getLatestCommit.defs'
export { main as default } from './getLatestCommit.defs'
